export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasins activés"])},
        "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pourcentage de magasins ayant réalisé au moins une vente sur la période et la vue sélectionnées."])}
      },
      "en": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active stores"])},
        "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Percentage of stores that made at least one sale during the selected period and view."])}
      }
    }
  })
}
